export enum ThrowAwayBannerAction {
  showModal = 'show modal',
  openSfaq = 'open sfaq',
}
